<template>
  <div class="row">
    <div class="flex md3">
      <va-button
        class="custom-button"
        :outline="opambColor === 'dark'"
        small
        :color="opambColor"
        :disabled="!opefStatus"
        @click="opambStatus = !opambStatus"
      >OPAM-B</va-button>
    </div>
    <div class="flex md3">
      <va-button
        class="custom-button"
        :outline="agromerColor === 'dark'"
        small
        :color="agromerColor"
        :disabled="!opefStatus"
        @click="agromerStatus = !agromerStatus"
      >AGROMER</va-button>
    </div>
    <div class="flex md3">
      <va-button
        class="custom-button"
        :outline="scappColor === 'dark'"
        small
        :color="scappColor"
        @click="scappStatus = !scappStatus"
      >SCAPP</va-button>
    </div>
    <div class="flex md3">
      <va-button
        class="custom-button"
        outline
        small
        disabled
        color="dark"
        @click="scappStatus = !scappStatus"
      >Fédération</va-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "otherAdhesion",
  props: ["identreprise", "opefStatus"],
  data() {
    return {
      initOpambStatus: false,
      initAgromerStatus: false,
      initScappStatus: false,
      scappUpdated: false,
      opambUpdated: false,
      agromerUpdated: false,
      toupdate: false,
      opambStatus: false,
      agromerStatus: false,
      scappStatus: false
    };
  },
  computed: {
    infosUpdated: function() {
      if (this.scappUpdated || this.opambUpdated || this.agromerUpdated) {
        return true;
      }
      return false;
    },
    scappColor: function() {
      if (this.initScappStatus !== this.scappStatus) {
        this.scappUpdated = true;
      } else {
        this.scappUpdated = false;
      }
      return this.scappStatus ? "success" : "dark";
    },
    opambColor: function() {
      if (this.initOpambStatus !== this.opambStatus) {
        this.opambUpdated = true;
      } else {
        this.opambUpdated = false;
      }

      return this.opambStatus ? "success" : "dark";
    },
    agromerColor: function() {
      if (this.initAgromerStatus !== this.agromerStatus) {
        this.agromerUpdated = true;
      } else {
        this.agromerUpdated = false;
      }

      return this.agromerStatus ? "success" : "dark";
    }
  },
  watch: {
    infosUpdated(newValue) {
      if (newValue) {
        this.$emit("infosChanged", true);
      } else {
        this.$emit("infosChanged", false);
      }
    },
    opefStatus(newvalue) {
      if (!newvalue) {
        this.scappStatus = false;
        this.opambStatus = false;
        this.agromerStatus = false;
      }
    },
    identreprise: {
      immediate: true,
      handler(newid) {
        if (newid) {
          this.loadAdhesions(newid);
        }
      }
    }
  },
  methods: {
    saveAdhesions(identreprise) {
      if (this.identreprise && this.identreprise !== identreprise) {
        this.launchEpicmaxToast("Incoherence lors de l'enregistrement");
        return;
      }
      let params = {
        adhesion: {
          identreprise: identreprise,
          opamb: this.opambStatus,
          agromer: this.agromerStatus,
          scapp: this.scappStatus
        }
      };
      axios
        .put("/api/other-adhesions-entreprise", params)
        .then(res => {
          this.$emit("updatedone", res.data);
          this.launchEpicmaxToast("Adhésions correctement sauvegardée");
        })
        .catch(err => {
          this.launchEpicmaxToast(
            "Les autres adhésions n'ont pas été correctement sauvegardées"
          );
        });
    },
    async loadAdhesions(id) {
      try {
        let adhesionList = await axios.get("/api/other-adhesions-entreprise", {
          params: {
            id: id
          }
        });
        this.opambStatus = adhesionList.data.opamb ? true : false;
        this.agromerStatus = adhesionList.data.agromer ? true : false;
        this.scappStatus = adhesionList.data.scapp ? true : false;

        this.initOpambStatus = this.opambStatus;
        this.initAgromerStatus = this.agromerStatus;
        this.initScappStatus = this.scappStatus;
        /*
        let adhesionsStatuts = await axios.get("/api/adhesion-statut", {
          params: {
            identreprise: id
          }
        });
        console.log(adhesionsStatuts);
        */
      } catch (error) {
        console.log(error);
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  }
};
</script>

<style lang="scss">
.custom-button {
  width: 95%;
  border-color: #40e583;
  border-width: 2px;
  border-style: solid;
}
</style>
